<!-- <button (click)="toggleFullscreen()" class="fullscreen-mode">
	{{ fullscreenService.isFullscreen() ? 'Exit Fullscreen' : 'Open Fullscreen' }}
</button> -->
<ng-container>
	<p class="printerStatus">Printer: {{ printerStatus }}</p></ng-container
>
<p class="version">{{ version }}</p>

<router-outlet></router-outlet>
